// Deterministic AI placeholder image per school
const NUM = 15;

function hashStr(s) {
  // simple djb2 → unsigned 32-bit
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = (((h << 5) + h) + s.charCodeAt(i)) | 0;
  return h >>> 0;
}

export function imageForSchool(id) {
  if (!id) return "/ai/school-1.jpg";
  const idx = (hashStr(id) % NUM) + 1;
  return `/ai/school-${idx}.jpg`;
}

export function citySlug(city) {
  if (!city) return "";
  return city
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['`’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
